<!-- MODAL -->
<ng-template #usrDireNotFoundOptions let-c="close">

  <div class="modal-header">
    <h5 class="modal-title" id="exampleModalLongTitle" translate>inv.usrDireNotFound.tittle
    </h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="c('cancel')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="container-fluid ESFsinDIRE text-center">
      <img src="assets/images/ico_aviso.png" class="text-center">

      <p [innerHTML]="'inv.usrDireNotFound.body' | translate:{ nif: person.identifier}"></p>
      <a href="{{ direUrl }}" (click)="c('goDire')" class="btn btn-primary" target="_blank" translate><i class="fa fa-list"></i> inv.usrDireNotFound.buttonDire</a>
      <hr>
      <p [innerHTML]="'inv.usrDireNotFound.body2' | translate:{}"></p>
    </div>
  </div>

  <div class="modal-footer">
  </div>

</ng-template>
<!-- FIN MODAL -->

<!-- Nopropia ESF Boton -->
<div class="botoneraESF text-right">
    <a type="button" class=" btn btn-primary botAltaESF_element_to_target" *ngIf="myInvoicingServices && myInvoicingServices.length > 1" [routerLink]="['/empresas/listado']"><i class="fa fa-eye"></i><span class="" translate>inv.createIS.autorizatedESFTitle</span></a>
    <a type="button" class="btn btn-primary botESFautorizada_element_to_target" *ngIf="!myInvoicingService.identifier && person.code" [routerLink]="['/empresas/nueva-empresa-servicio-facturacion']"><i class="fa fa-plus"></i><span class="" [innerHTML]="'inv.createIS.noESFBtFullButton' | translate:{ nif: person.identifier}"></span></a>
    <a type="button" class="btn btn-primary botESFautorizada_element_to_target" *ngIf="!myInvoicingService.identifier && !person.code" (click)="openUsrDireNotFoundOptions()"><i class="fa fa-plus"></i><span class="" [innerHTML]="'inv.createIS.noESFBtFullButton' | translate:{ nif: person.identifier}"></span></a>
</div>

<!--FIN  Nopropia ESF Boton-->
<app-inv-company-info [person]="invoicingService"></app-inv-company-info>

<router-outlet></router-outlet>


<ul id="tlyPageGuideESF" data-tourtitle="Home de FACeB2B" class="d-none">


  <!--ESF CON AUTORIZADAS-->

      <li class="tlypageguide_bottom" data-tourtarget=".tipo_element_to_target">
      <div>
        Desde esta pestaña podrá actuar como ESF o como Cliente sin tener que volver a loguearse.
      </div>
    </li>
  <li class="tlypageguide_top" data-tourtarget=".ESFAutorizadas_element_to_target">
    <div>
      <p>
        Si es autorizado en varias ESF podrá acceder al listado de sus ESF y seleccionar la que necesite en cada momento. Para mayor comodidad podrá seleccionar que se le muestre una por defecto.
      </p>
      </div>
  </li>
  <li class="tlypageguide_top" data-tourtarget=".noESF_element_to_target">
    <div>
        <p>Para poder trabajar como Empresa de Servicio de Facturación en FACeB2B hay que tener un certificado electrónico válido y haberse dado de alta previamente en DIRe. </p>
        <p>En FACeB2B como ESF, puede gestionar las facturas de las unidades receptoras de sus clientes, o las suyas propias, a través de las Plataformas de Facturación.</p>
        <p>La primera vez en FACeB2B tendrá que darse de alta que se firmará con el miniapplet de @firma. <a href="http://firmaelectronica.gob.es/Home/Descargas.html" target="_blank">Descárguelo aquí</a></p>
      </div>
  </li>


<!--ESF TABS-->

    <li class="tlypageguide_bottom" data-tourtarget=".tipo_element_to_target">
      <div>
        Desde esta pestaña podrá actuar como ESF o como Cliente sin tener que volver a loguearse.
      </div>
    </li>
    <li class="tlypageguide_right" data-tourtarget=".botESFautorizada_element_to_target">
      <div>
        Este botón muestra las ESF en las que está autorizado para administrar.
      </div>
    </li>
    <li class="tlypageguide_top" data-tourtarget=".botAltaESF_element_to_target">
      <div>
        <p>Para poder trabajar como Empresa de Servicio de Facturación en FACeB2B hay que tener un certificado electrónico válido y haberse dado de alta previamente en DIRe. </p>
        <p>En FACeB2B como ESF, puede gestionar las facturas de las unidades receptoras de sus clientes, o las suyas propias, a través de las Plataformas de Facturación.</p>
      </div>
    </li>
  <li class="tlypageguide_top" data-tourtarget=".datos_element_to_target">
    <div>
         <p>Los datos de la entidad son obtenidos del sistema DIRe. Si desea actualizar la información de su empresa desde DIRe a FACeB2B pulse en <b class="apunteDescacado">[ <i _ngcontent-c5="" class="fa fa-refresh"></i> ] </b> </p>

         <p>Los administradores de la ESF se pueden dar de alta o gestionar pulsando <b class="apunteDescacado">[ <i _ngcontent-c5="" class="fa fa-users"></i> ] </b> </p>

         <p>Si en algún momento quiere modificar su dirección de correo, empezar a dar servicio a terceros, o dejar de proporcionarlo lo puede hacer pulsando <b class="apunteDescacado">[ <i _ngcontent-c5="" class="fa fa-pencil"></i> ] </b></p>
      </div>
  </li>

  <li class="tlypageguide_top pestana" data-tourtarget=".tabPlataformaF_element_to_target">
    <div>
      <p>
      Las facturas electrónicas en FACeB2B se gestionan a través de las Plataformas de Facturación (PF), asociando un certificado electrónico válido que deberá ser el utilizado en las llamadas de los servicios web. Puede crear tantas PF como requiera, y gestionarlas en cualquier momento.
      </p>
    </div>
  </li>
  <li class="tlypageguide_top pestana" data-tourtarget=".tabAltaCliente_element_to_target">
    <div>
      <p>
      Sus Clientes que deseen utilizar FACeB2B a traves de alguna de sus plataformas de facturación (PF) le remitirán una autorización para gestionar su unidad receptora. Para ello deberá aceptar la autorización y asignarle una PF. Las autorizaciones también pueden ser rechazadas.
      </p>
    </div>
  </li>
    <li class="tlypageguide_top pestana" data-tourtarget=".tabClientesR_element_to_target">
      <div>
        <p>
        La gestión de sus clientes receptores se hará desde esta pesataña. Podrá cambiarles la PF asignada, o desactivar/reactivar la relación con ellos.
        </p>
      </div>
  </li>

</ul>




<div class="tlyPageGuideWelcome">
    <p><img src="assets/images/logoB2B-white.png" alt="logo FACeB2B"></p>
    <p>Bienvenido a FACeB2B ¿quiere conocer más acerca de esta plataforma?</p>
    <p><button class="tlypageguide_start">Ver Tutorial</button> <button class="tlypageguide_dismiss negativo">Omitir tutorial</button></p>
		<hr />
    <p class="notaPie">Para volver a acceder a este resumen puede hacerlo pulsaldo <b>Guía de uso</b> en el menu del pie de página</p>
</div>



// WEBPACK FOOTER //
// ./src/app/app-manager/invoicing-services/inv.component.html